import { endRoute } from '$shared/utils/routes';

export const matchListLandingRoutes = {
  matchList: endRoute('/ml'),
};
